<template>
  <div
    v-click-outside="hide"
    class="icon-dropdown dropdown"
    :class="{ 'show': show }"
  >
    <div class="flex bg-white-blue items-center">
      <button
        :id="id"
        class="dropdown-toggle p-0 inline-flex grow items-center bg-transparent"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        @click="toggle"
      >
        <div class="icon-dropdown-icon h-[60px] bg-medium-blue p-3 text-white flex justify-center items-center">
          <fa
            class="w-auto"
            :icon="icon"
          />
          <slot name="icon" />
        </div>
        <div
          class="px-2 py-2 ml-2 icon-dropdown-text w-full relative"
          :class="{ 'font-bold': value === null }"
        >
          <span class="absolute truncate top-0 left-0 w-full text-left -mt-1 pl-0 md:pl-2">
            <slot
              v-if="!value && $slots.placeholder"
              name="placeholder"
            />
            <span v-else>
              {{ value?.text ?? value?.value ?? placeholder }}
            </span>
          </span>
        </div>
        <fa
          class="h5 mb-0 mr-4 transition-transform"
          icon="chevron-down"
          :style="{ transform: `rotateX(${show ? '180deg' : '0'})` }"
        />
      </button>
      <fa
        v-if="value !== null"
        class="h5 mb-0 ml-auto mr-4 transition-transform z-[5] text-gray cursor-pointer"
        icon="circle-xmark"
        @click="clear"
      />
    </div>
    <div
      class="dropdown-menu w-full overflow-auto shadow-below-light rounded-top-0 m-0 p-0 border-0"
      :aria-labelledby="id"
      :class="{ 'show': show }"
      :style="{ maxHeight: dropdownMaxHeight }"
    >
      <div class="size-full p-2">
        <div
          v-for="(option, index) in options"
          :key="option.id ?? option.text ?? index"
          class="dropdown-item py-0 px-4"
          :class="{ 'active': getCompareValue(option) === getCompareValue(value) }"
        >
          <div
            class="cursor-pointer py-2 border-light-gray flex"
            :class="{ 'border-b': index !== options.length - 1 }"
            @click="select(option)"
          >
            <template v-if="option?.text ?? option?.value">
              {{ option?.text ?? option?.value }}
            </template>
            <div class="ml-auto">
              {{ option.endText }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default defineNuxtComponent({
  setup () {
    const id = useId().replaceAll('_', '-')

    return {
      id,
    }
  },

  props: {
    /**
     * @prop {{
     *   text: string | number
     *   value?: any
     *   id?: number
     *   endText?: string | number
     * }} value
     */
    value: {
      type: Object,
      default: null,
    },

    placeholder: {
      type: [String, Number],
      default: null,
    },

    /**
     * @prop {Array<@prop value>} options
     */
    options: {
      type: Array,
      default: () => [],
    },

    icon: {
      type: String,
      default: null,
    },

    dropdownMaxHeight: {
      type: String,
      default: '300px',
    },
  },

  emits: ['onSelect'],

  data () {
    return {
      show: false,
    }
  },

  methods: {
    select (option) {
      this.show = false
      this.$emit('onSelect', option)
    },

    clear () {
      this.show = false
      this.$emit('onSelect', null)
    },

    toggle () {
      this.show = !this.show
    },

    hide () {
      this.show = false
    },

    getCompareValue (obj) {
      return obj?.id ?? obj?.text ?? obj?.value
    },
  },
})
</script>

<style lang="scss" scoped>
.icon-dropdown {
  .active,
  .dropdown-item:active,
  .dropdown-item:hover,
  .dropdown-item:focus {
    background-color: theme('colors.white-blue') !important;
    color: black;
  }

  &-icon {
    svg {
      height: 100%;
      width: 100%;
    }
  }

  &-text {
    @media (max-width: theme('screens.md')) {
      font-size: .9rem;
    }
  }
}
</style>
